"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScripts = getScripts;
exports.getImages = getImages;
exports.isImage = isImage;
var map_1 = __importDefault(require("licia/map"));
var filter_1 = __importDefault(require("licia/filter"));
var compact_1 = __importDefault(require("licia/compact"));
var contain_1 = __importDefault(require("licia/contain"));
var endWith_1 = __importDefault(require("licia/endWith"));
var isPerformanceSupported = false;
var performance = window.webkitPerformance || window.performance;
if (performance && performance.getEntries) {
    isPerformanceSupported = true;
}
function getScripts() {
    if (isPerformanceSupported) {
        return getResources('script');
    }
    var elements = document.querySelectorAll('script');
    return (0, compact_1.default)((0, map_1.default)(elements, function (element) { return element.src; }));
}
function getImages() {
    if (isPerformanceSupported) {
        return getResources('img');
    }
    var elements = document.querySelectorAll('img');
    return (0, compact_1.default)((0, map_1.default)(elements, function (element) { return element.src; }));
}
function isImage(url) {
    return (0, contain_1.default)(getImages(), url);
}
function getResources(type) {
    return (0, map_1.default)((0, filter_1.default)(performance.getEntries(), function (entry) {
        if (entry.entryType !== 'resource') {
            return false;
        }
        if (entry.initiatorType === type) {
            return true;
        }
        else if (entry.initiatorType === 'other') {
            if (type === 'script') {
                if ((0, endWith_1.default)(entry.name, '.js')) {
                    return true;
                }
            }
        }
        return false;
    }), function (entry) { return entry.name; });
}
